import FullBoardConst from '../constants/full_board.constants';

export const AddBoardFavData = data => ({
  type: FullBoardConst.FULL_BRD_FAV_ADD,
  value: data,
});

export const DelBoardFavData = data => ({
  type: FullBoardConst.FULL_BRD_FAV_DEL,
  value: data,
});

export const UpdateBoardWsData = data =>({
  type: FullBoardConst.UPDATE_BOARD_DATA, value: data
})